import { render } from "./CopyChanges.vue?vue&type=template&id=b2126242&ts=true"
import script from "./CopyChanges.vue?vue&type=script&lang=ts"
export * from "./CopyChanges.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__